import React, { createContext, useCallback } from "react";
import { SystemType, PropsSystemType } from "./props";
import { useSessionStorage } from "react-use";

export const DEFAULT_VALUE = {
  systemConfig: {
    theme: "light",
    showBalance: true,
    showTransfer: true,
    showLeadModal: true,
    menuManagerDesktopOpen: true,
  },
  update: () => { },
};

const SystemContext = createContext<PropsSystemType>(DEFAULT_VALUE);

const SystemContextProvider: React.FC = ({ children }) => {
  const [data, setData] = useSessionStorage<SystemType>("system-store", DEFAULT_VALUE.systemConfig);

  const update = useCallback(
    (settings: SystemType) => {
      setData(settings);
    },
    [setData]
  );

  return (
    //@ts-ignore
    <SystemContext.Provider value={{ systemConfig: data, update }}>{children}</SystemContext.Provider>
  );
};

export { SystemContextProvider };
export default SystemContext;
